import { Component, effect, forwardRef, inject, Input } from '@angular/core';
import { DropdownModule } from 'primeng/dropdown';
import {
  AbstractControl,
  ControlValueAccessor,
  FormsModule,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule,
} from '@angular/forms';
import { SharedModule } from 'primeng/api';
import { FormFieldWrapperComponent } from '../../molecules/form-field-wrapper/form-field-wrapper.component';
import { MultiSelectModule } from 'primeng/multiselect';
import { WorkspaceStore } from '../../../stores/workspace/workspace.state';
import {
  asWorkspaceTypeKey,
  Workspace,
  workspaceTypeIconMap,
  WorkspaceTypeKey,
} from '../../../models/workspace';
import { getState } from '@ngrx/signals';
import { AlertComponent } from '../alert/alert.component';
import { Button } from 'primeng/button';
import { RouterLink } from '@angular/router';
import { GlobalsStore } from '../../../stores/globals.state';

@Component({
  selector: 'app-workspace-dropdown',
  standalone: true,
  imports: [
    DropdownModule,
    ReactiveFormsModule,
    SharedModule,
    FormsModule,
    FormFieldWrapperComponent,
    MultiSelectModule,
    AlertComponent,
    Button,
    RouterLink,
  ],
  templateUrl: './workspace-dropdown.component.html',
  styleUrl: './workspace-dropdown.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => WorkspaceDropdownComponent),
      multi: true,
    },
  ],
})
export class WorkspaceDropdownComponent implements ControlValueAccessor {
  readonly workspaceStore = inject(WorkspaceStore);
  readonly globalsStore = inject(GlobalsStore);

  selection: string[] = [];
  touched = false;
  disabled = false;
  workspaces: Workspace[] = [];

  constructor() {
    effect(() => {
      const wsState = getState(this.workspaceStore);
      if (wsState.initialized) {
        this.workspaces = this.type
          ? this.workspaceStore.filterByType(this.type)
          : this.workspaceStore.asArray();
      }

      if (wsState.selectedId && wsState.action === 'add') {
        const selection = [...this.selection] || [];
        selection.push(wsState.selectedId);
        this.writeValue(selection);
      }
    });
  }

  @Input() label = 'Arbeitsbereiche';
  @Input() name = 'workspace';
  @Input() type?: WorkspaceTypeKey;
  @Input() colSize: string | number = 12;
  @Input() formField: AbstractControl | null = null;
  @Input() enableNewOption = true;

  protected onChange = (value: any) => {};
  private onTouched = () => {
    this.touched = false;
  };

  writeValue(value: any): void {
    this.selection = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  selectIcon(tag: any): void {
    this.selection = tag;
    this.onChange(tag);
    this.onTouched();
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  protected readonly workspaceTypeIconMap = workspaceTypeIconMap;
  protected readonly asWorkspaceTypeKey = asWorkspaceTypeKey;

  openWorkspaceForm() {
    this.globalsStore.triggerAtlasEvent('addWorkspaceDialog', {
      key: this.type || '',
    });
  }
}
